import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ApiDefinition } from '../../types/api-definitions';
import { useLocalizedFeatures } from '../../hooks/useLocalizedContent';
import FeatureDisplay from '../common/FeatureDisplay';

interface FeaturesTabProps {
  apiDefinition: ApiDefinition;
}

const FeaturesTab: React.FC<FeaturesTabProps> = ({ apiDefinition }) => {
  const { t } = useTranslation();
  const features = useLocalizedFeatures(apiDefinition);

  if (features.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant='body1' color='text.secondary'>
          {t('apiDetail.featuresTab.noFeatures')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {features.map((feature) => (
          <Card key={feature.id} variant='apiCard' sx={{ cursor: 'default' }}>
            <CardContent sx={{ p: 2 }}>
              <FeatureDisplay feature={feature} description={feature.descriptionLong} />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default FeaturesTab;
